import { FormControl, IconButton, InputAdornment, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import React, { useState } from 'react';
import { useController, useFormContext } from 'react-hook-form';
import ListIcon from '@mui/icons-material/List';

export const resolutions = [
  '3840x2160',
  '2688x1520',
  '1920x1080',
  '1280x720',
  '1280x800',
  '800x450',
  '800x480',
  '704x480',
  '800x600',
  '640x480',
];

type Props = {
  name: string;
  defaultValue?: string;
  required?: boolean;
  label?: string;
};

export default function Resolution({ name, defaultValue, required, label }: Props) {
  const { setValue, getValues } = useFormContext();
  const {
    field: { ref, onChange, onBlur, value },
    fieldState: { error },
  } = useController({
    name: name,
    defaultValue: defaultValue,
    rules: {
      required: required ? 'value required' : false,
      pattern: { value: /^(\d*)x(\d*)$/, message: 'invalid format' },
    },
  });

  const [showCustom, setShowCustom] = useState(() => {
    const value = getValues(name);
    return resolutions.indexOf(value) == -1;
  });

  const onSelectChange = (evt: any) => {
    if (evt.target.value == 'custom') {
      setShowCustom(true);
    } else {
      setShowCustom(false);
      onChange(evt);
    }
  };

  const onInputChange = (evt: any) => {
    onChange(evt.target.value);
  };

  const onClick = () => {
    setShowCustom(false);
    setValue(name, defaultValue);
  };

  return (
    <>
      {!showCustom && (
        <FormControl fullWidth>
          <InputLabel shrink>{label || 'Resolution'}</InputLabel>
          <Select label={label || 'Resolution'} value={value} onChange={onSelectChange} onBlur={onBlur}>
            {resolutions.map((value) => (
              <MenuItem key={value} value={value}>
                {value}
              </MenuItem>
            ))}
            <MenuItem key="custom" value="custom">
              Custom
            </MenuItem>
          </Select>
        </FormControl>
      )}
      {showCustom && (
        <TextField
          label={label || 'Resolution'}
          required={!!required}
          inputRef={ref}
          onChange={onInputChange}
          value={value}
          onBlur={onBlur}
          error={!!error}
          helperText={error ? error.message : null}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={onClick}>
                  <ListIcon style={{ cursor: 'pointer' }} />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      )}
    </>
  );
}
